import script from "./Hub.vue?vue&type=script&setup=true&lang=js"
export * from "./Hub.vue?vue&type=script&setup=true&lang=js"

import "./Hub.vue?vue&type=style&index=0&id=1e46a864&lang=css"
import "./Hub.vue?vue&type=style&index=1&id=1e46a864&scoped=true&lang=css"

import exportComponent from "/home/runner/work/INPEOPLE-HUB/INPEOPLE-HUB/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1e46a864"]])

export default __exports__